@for (niveau of data; track niveau) {
	<div class="label">
		<span>{{ niveau }}</span>
	</div>
	@if (!$last) {
		<div class="gap"></div>
	}
}
